module.exports = __webpack_public_path__ + "img/plus.7c6c8212.svg";